import template from './colorPicker.template.html';

export default {
  template,
  bindings: {
    color: '<',
    isVisible: '<',
    onPick: '&'
  },
controller: class controller {
    constructor(Color) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.colors = Color.available();
      ctrl.showPickerButton = true;
      ctrl.showColors = false;

      /*
       * Event Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.pickColor = function (c) {
        ctrl.showColors = false;
        ctrl.color = c;
        ctrl.onPick({ c: ctrl.color });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        if (ctrl.isVisible === false) {
          ctrl.showPickerButton = false;
        }
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.isVisible) {
          ctrl.showColors = changes.isVisible.currentValue;
        }
      };
    }
  }
};
